import React from 'react'
import PropTypes from 'prop-types'

export default function TopRightVignette ({ fill, ...others }) {
  return (
    <svg
      width="463"
      height="462"
      viewBox="0 0 463 462"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...others}
      aria-hidden="true"
    >
      <g opacity="0.5">
        <circle
          cx="45.9162"
          cy="45.9162"
          r="45.9162"
          transform="matrix(1 0 0 -1 278.166 184.767)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle
          cx="20.9174"
          cy="20.9174"
          r="20.9174"
          transform="matrix(1 0 0 -1 303.164 159.768)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(1 0 0 -1 278.166 276.599)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(1 0 0 -1 92.9941 92.9351)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(1 0 0 -1 370 92.9351)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(1 0 0 -1 370 368.972)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M278.006 142.038C278.006 165.759 258.776 184.989 235.055 184.989L184.989 184.989L184.989 92.9943L278.006 92.9943L278.006 142.038Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M184.989 1.00001L184.989 92.9945L278.006 92.9945L184.989 1.00001Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M278.005 92.9941L278.005 0.999671L184.988 0.999671L278.005 92.9941Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M369.838 460.972V369.14H278.006L369.838 460.972Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M369.838 277.145L278.006 277.145L278.006 368.978L369.838 277.145Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M369.998 1.10272L278.166 1.10273L278.166 92.9351L369.998 1.10272Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M278.166 368.978L369.998 368.978L369.998 277.146L278.166 368.978Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M92.8323 92.9946L92.8323 1.1623L1 1.1623L92.8323 92.9946Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M370 92.9722L370 184.972L461 184.972L370 92.9722Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M461.832 369.14L370 369.14L370 460.973L461.832 369.14Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M278.166 92.9349L369.998 92.9349L369.998 1.10254L278.166 92.9349Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M370 276.972L461.832 276.972L461.832 185.14L370 276.972Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

TopRightVignette.defaultProps = {
  fill: 'white',
}

TopRightVignette.propTypes = {
  fill: PropTypes.string,
}
